import React from 'react';
import { Button, Space, Tooltip } from 'antd';
import { EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';

interface ActionButtonsProps {
  /**
   * Callback al hacer click en editar
   */
  onEdit?: () => void;
  /**
   * Callback al hacer click en eliminar
   */
  onDelete?: () => void;
  /**
   * Callback al hacer click en ver
   */
  onView?: () => void;
  /**
   * Muestra botón de editar
   * @default true
   */
  showEdit?: boolean;
  /**
   * Muestra botón de eliminar
   * @default true
   */
  showDelete?: boolean;
  /**
   * Muestra botón de ver
   * @default false
   */
  showView?: boolean;
  /**
   * Tooltips personalizados
   */
  tooltips?: {
    edit?: string;
    delete?: string;
    view?: string;
  };
  /**
   * Deshabilita los botones
   */
  disabled?: boolean;
}

/**
 * Componente reutilizable para acciones inline en tablas
 * Incluye botones de editar, eliminar y ver con íconos
 */
export const ActionButtons: React.FC<ActionButtonsProps> = ({ 
  onEdit,
  onDelete,
  onView,
  showEdit = true,
  showDelete = true,
  showView = false,
  tooltips = {},
  disabled = false
}) => {
  return (
    <Space size="small">
      {showView && onView && (
        <Tooltip title={tooltips.view || "Ver"}>
          <Button 
            type="default"
            icon={<EyeOutlined />} 
            onClick={onView}
            size="small"
            disabled={disabled}
          />
        </Tooltip>
      )}
      {showEdit && onEdit && (
        <Tooltip title={tooltips.edit || "Editar"}>
          <Button 
            type="primary"
            icon={<EditOutlined />} 
            onClick={onEdit}
            size="small"
            disabled={disabled}
          />
        </Tooltip>
      )}
      {showDelete && onDelete && (
        <Tooltip title={tooltips.delete || "Eliminar"}>
          <Button 
            type="primary"
            danger
            icon={<DeleteOutlined />} 
            onClick={onDelete}
            size="small"
            disabled={disabled}
          />
        </Tooltip>
      )}
    </Space>
  );
};

